"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgreeFitProtocal = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var financial_1 = require("../../model/financial");
var service_1 = require("../../../library/base/service");
var AgreeFitProtocal = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(AgreeFitProtocal, _super);
    function AgreeFitProtocal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '用户同意协议接口';
        _this.code = '101108';
        _this.desc = "";
        _this.requestParams = new financial_1.AgreeFitProtocalRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return AgreeFitProtocal;
}(service_1.BaseService));
exports.AgreeFitProtocal = AgreeFitProtocal;
//# sourceMappingURL=agreeFitProtocal.js.map